import React, { useState } from "react";
import Surveyor from "./surveyor.svg";
import Avatar from "./public.svg";
import Graduates from "./student.svg";

const dropdownData = [
  {
    icon: Avatar,
    alt: "consumers",
    label: "FOR PUBLIC",
    items: [
      { href: "/titlesurv", label: "USE OF TITLE LICENSED SURVEYOR" },
      { href: "/engagesurv", label: "WHY ENGAGE A LICENSED SURVEYOR" },
      { href: "/register", label: "FIND A LICENSED SURVEYOR" },
      { href: "/compliments", label: "COMPLIMENT A SURVEYOR" },
      { href: "/inquiries", label: "MAKE AN INQUIRY" },
      { href: "/complaints", label: "SUBMIT A COMPLAINT" },
      { href: "/report", label: "REPORT AN OFFENSE" },
    ],
  },
  {
    icon: Surveyor,
    alt: "surveyors",
    label: "FOR LICENSED SURVEYORS",
    items: [
      { href: "/annuallicence", label: "PRACTICING CERTIFICATE RENEWALS" },
      { href: "/resources", label: "GUIDELINES" },
    ],
  },
  {
    icon: Graduates,
    alt: "graduates",
    label: "FOR GRADUATES",
    items: [
      { href: "/surveyorreg", label: "LICENSE APPLICATION CHECKLIST" },
      { href: "/trialSurvey", label: "TRIAL SURVEY GUIDELINES" },
      { href: "/approvedreg", label: "APPROVED ASSISTANTS APPLICATION GUIDELINES" },
      { href: "/landlaw", label: "APPLICATION TO SIT LAND LAW EXAMINATION" },
      { href: "/resources", label: "LAND LAW EXAMINATION PAST PAPERS" },
      { href: "/resources", label: "LAND LAW EXAMINATION TIMETABLE" },
    ],
  },
];

const NavItems = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleDropdown = (idx) => {
    if (window.innerWidth < 1024) {
      setOpenIndex((prev) => (prev === idx ? null : idx));
    }
  };

  return (
    <nav className="bg-black flex justify-between py-2 px-5 relative w-full">
      {dropdownData.map((section, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={idx}
            className="relative group w-1/3 flex flex-col items-center"
            onMouseEnter={() => window.innerWidth >= 1024 && setOpenIndex(idx)}
            onMouseLeave={() => window.innerWidth >= 1024 && setOpenIndex(null)}
          >
            {/* Top Level Button */}
            <button
              onClick={() => toggleDropdown(idx)}
              className="flex flex-col items-center text-white gap-2 select-none focus:outline-none"
              style={{ width: "100%" }}
              id="navitem_link"
            >
              <img src={section.icon} alt={section.alt} className="w-10" />
              <div className="font-medium tracking-wide" style={{ fontSize: "calc(.5em + .3vw)" }}>{section.label}</div>
            </button>

            {/* Dropdown Panel */}
            <div
              className={`
                absolute left-0 top-full w-full bg-white text-black border border-gray-200 overflow-hidden z-[1000] transition-all duration-200 ease-out origin-top
                ${isOpen ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-95 pointer-events-none"}
              `}
              style={{
                width: "100%",
                textAlign: "left",
              }}
            >
              <div className="flex flex-col w-full">
                {section.items.map((item, j) => (
                  <a
                    key={j}
                    href={item.href}
                    className="block px-4 py-2 font-medium text-black no-underline transition-colors duration-300 hover:font-bold text-sm text-left"
                    id="navitem_link"
                    style={{ textAlign: "left" }}
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
};

export default NavItems;
